import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AzureAuthService } from 'app/core/auth/azure-auth.service';
import { Observable, map } from 'rxjs';

export const AdminGuard: CanActivateFn | CanActivateChildFn = (
    route,
    state
): Observable<boolean | import('@angular/router').UrlTree> => {
    const router: Router = inject(Router);
    const _authService = inject(AzureAuthService);

    // Check if the user is an admin
    return _authService.isAdmin().pipe(
        map((isAdmin) => {
            if (isAdmin) {
                return true;
            } else {
                // Redirect to a default route if not an admin
                return router.parseUrl('');
            }
        })
    );
};
